import React, { useRef } from 'react';
import classNames from 'classnames/bind';
import { getLoginUrl } from 'redux/modules/auth';
import PropTypes from 'prop-types';
import Modal from '../Modal/Modal';
import walletProviders from '../../config/walletProviders';
import styles from './assets/styles.scss';
import { useMobileOnly } from '../../helpers/responsive';
import useClickOutside from '../../helpers/useClickOutside';
import usePageScroll from '../../helpers/usePageScroll';
import useLocationChange from '../../helpers/useLocationChange';
import BottomDrawer from '../BottomDrawer/BottomDrawer';

import IconClose from '../Modal/assets/close.svg?inline';

const cx = classNames.bind(styles);

export default function ConnectWallet({ isOpen, onClose, buttonRefs }) {
  const isMobileOnly = useMobileOnly();
  const popupRef = useRef();

  useClickOutside(() => {
    onClose(false);
  }, [popupRef, ...buttonRefs]);
  usePageScroll(() => onClose(false));
  useLocationChange(() => onClose(false));

  const walletOptions = Object.keys(walletProviders).map(provider => (
    <button
      type="button"
      className={cx('wallet-option')}
      key={provider}
      onClick={() => {
        window.location.href = getLoginUrl(provider);
      }}
    >
      <img src={walletProviders[provider].icon} alt={provider} />
      <span className={cx('xlarge', 'bold')}>{walletProviders[provider].label}</span>
    </button>
  ));
  const bottomContent = (
    <div className={cx('bottom-content')}>
      <p>Don't have a Bitcoin SV Wallet?</p>
      <a href="https://app.handcash.io/#/authenticate" className={cx('bold')}>
        Create a free BSV Wallet
      </a>
    </div>
  );

  return (
    <>
      {isMobileOnly ? (
        <BottomDrawer isOpen={isOpen} className={cx('connect-wallet-popup')} ref={popupRef}>
          <div className={cx('header')}>
            <h4>Connect Wallet</h4>
            <button type="button" onClick={onClose}>
              <IconClose />
            </button>
          </div>
          {walletOptions}
          {bottomContent}
        </BottomDrawer>
      ) : (
        <Modal isOpen={isOpen} onClose={onClose} header="Connect Wallet" modalClassName={cx('modal')}>
          {walletOptions}
          <div className={cx('modal-footer')}>{bottomContent}</div>
        </Modal>
      )}
    </>
  );
}
ConnectWallet.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  buttonRefs: PropTypes.array.isRequired,
};
